import { StyleFunctionProps } from '@chakra-ui/react';
import { theme } from '@ramp/theme';

// Header texts come from Redlex in their final case; the Ramp table theme would capitalise every word.
const rampTable = theme.components.Table;
const rampTableBase = rampTable.baseStyle;

theme.components.Table = {
  ...rampTable,
  baseStyle: (props: StyleFunctionProps) => {
    const style = typeof rampTableBase === 'function' ? rampTableBase(props) : rampTableBase;

    return { ...style, thTag: { ...style?.thTag, textTransform: 'none' } };
  }
};
